import { Checkbox } from '@/components/catalyst/checkbox'

interface FormCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  className?: string
}

export default function FormCheckbox({ checked, onChange, className }: FormCheckboxProps) {
  return <Checkbox checked={checked} onChange={onChange} color="indigo" className={className} />
}
